import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from 'react-tooltip'
import Sidenavbar from '../../Components/Sidenavbar/Sidenavbar';
import UserMenu from '../../Components/UserMenu/UserMenu';
import { fetchData, postData, deleteData } from '../../Services/apiService';
import TableDocuments from '../../Components/Table/TableDocuments';


const AdminDocuments = () => {
  const userType = 'admin';
  const [key, setKey] = useState('home');
  const [show, setShow] = useState(false)
  const [rows, setRows] = React.useState([]);
  const [rowsApproved, setRowsApproved] = React.useState([]);
  const [rowsRejected, setRowsRejected] = React.useState([]);
  const [rowsTrained, setRowsTrained] = React.useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState({ id: null, name: '' });


  const [activeTab, setActiveTab] = useState('new');
  
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("es-MX", {
      timeZone: "UTC",
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };
  const transformDataToRows = (data, status) => {
    if (!data || !Array.isArray(data.data)) return []; 
  
    return data.data
      .filter(item => item && item.idStatus === status) 
      .map(item => {
        if (!item.userFileName || !item.idUploaderUser || !item.createDate) return null; 
  
        const row = [
          item.userFileName || "Sin nombre",
          item.idUploaderUser || "Desconocido",
          formatDate(item.createDate || new Date()),
        ];
  
        const statusLabels = {
          1: "Pendiente",
          2: "Aprobado",
          3: "Rechazado",
          4: "Incorporado al modelo"
        };
  
        row.push(statusLabels[item.idStatus] || "Desconocido");
  
        
        if(item.idStatus === 4)  {
          row.push(
            <span className="d-flex" key={item.idFile}>
              <a href={`/ViewDocument/${item.idFile}`}>
                <button className="-icon mr-16" data-tooltip-id="edit-tooltip" data-tooltip-content="Ver Documento" data-tooltip-place="bottom">
                  <i className="fa-solid fa-eye"></i>
                </button>
              </a>
              <button 
                className="-icon btn-sm btn-danger" data-tooltip-id="delete-tooltip" data-tooltip-content="Eliminar Documento" data-tooltip-place="bottom"
                onClick={() => handleDeleteClick(item.idFile, item.userFileName)} 

              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </span>
          );
        }
        else {
          row.push(
            <span className="d-flex" key={item.idFile}>
              <a href={`/ViewDocument/${item.idFile}`}>
                <button className="-icon mr-16" data-tooltip-id="edit-tooltip" data-tooltip-content="Editar usuario" data-tooltip-place="bottom">
                  <i className="fa-solid fa-eye"></i>
                </button>
              </a>
            </span>
          );
        }
  
        return row;
      })
      .filter(row => row !== null); 
  };
  const handleDeleteClick = (fileId, fileName) => {
    setSelectedFile({ id: fileId, name: fileName });
    setShowDeleteModal(true);
  };
  const confirmDelete = async () => {
    if (!selectedFile) return;
    try {
      await deleteData(`File?idDocument=${selectedFile.id}`);
      toast.success('Documento eliminado correctamente');
      fetchRequestsData();
    } catch (error) {
      toast.error('Error al eliminar el documento');
    }
    setShowDeleteModal(false);
  };
  
  useEffect(() => {
    fetchRequestsData();
  }, []);
  const fetchRequestsData = async () => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const idUser = user.id || 0;
    try {
      const body = {
        idUser: idUser,
      };
      const data = await postData('File/GetFiles', body);
      const rows = transformDataToRows(data, 1);
      const rowsA = transformDataToRows(data, 2);
      const rowsR = transformDataToRows(data, 3);
      const rowsE = transformDataToRows(data, 4);
    
      setRows(rows); 
      setRowsApproved(rowsA);
      setRowsRejected(rowsR);
      setRowsTrained(rowsE);
    } catch (error) {
      console.error('Error fetching data:', error);
     
    }
  };

  const trainingCompleted = async () => {
    const trainPromise = new Promise(async (resolve, reject) => {
      try {
        const body = { idStatus: 2 };
        const data = await postData("File/Train", body);
  
        if (!data.succes) {
          const errorMessage = data.errors
            ? `Error en el reentrenamiento: ${Array.isArray(data.errors) ? data.errors.join(", ") : data.errors}`
            : "Error en el reentrenamiento, vuelva a intentar";
          return reject(new Error(errorMessage)); // Usa `new Error()` para asegurar compatibilidad con toast.promise
        }
        resolve("Reentrenamiento realizado");
      } catch (error) {
        return reject(new Error("Error en el reentrenamiento, vuelva a intentar"));
      }
      fetchRequestsData();
    });
  
    toast.promise(
      trainPromise,
      {
        pending: "Realizando reentrenamiento...",
        success: "Reentrenamiento realizado",
        error: {
          render({ data }) {
            return data.message; 
          },
        },
      },
      {
        position: "top-center",
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      }
    );
  };
  

  return (
    
    <div className="container-fluid px-0 m-0 d-flex flex-column flex-md-row">
          

      <Sidenavbar userType={userType} />
      <div className="container-fluid px-16">
        <UserMenu userType="admin" />
      <Modal
          size="lg"
          show={showDeleteModal} onHide={() => setShowDeleteModal(false)}
          aria-labelledby="modal-change-request-status"
        >
          <Modal.Header className="justify-content-center">
            <Modal.Title>Confirmar Eliminación</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col">
                <p className="body-2">
                ¿Estás seguro de que deseas eliminar el documento <strong>{selectedFile.name}</strong>?
                </p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row justify-content-end">
              <div className="col-12 col-md-6 col-lg-4">
                <button className="btn -secondary" onClick={() => setShowDeleteModal(false)}>
                  Cancelar
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <button className="btn -primary" onClick={confirmDelete}>
                  Eliminar
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>


        {/* Main page, tabs view */}
        <>
          <div className="row mt-40 ml-16 justify-content-end">
          <Tooltip id="edit-tooltip" />
          <Tooltip id="delete-tooltip" />
            <Tabs
              id="controlled-tab-example"
              activeKey={activeTab}
              onSelect={handleTabChange}
              className="mb-3"
              variant="underline"
            >
              <Tab eventKey="new" title="Nuevos">
                <div className="row mt-24 justify-content-end">
                  <div className="col-12 col-md-6 col-lg-4">
                    <button className="btn -secondary" onClick={trainingCompleted}>
                      <i class="fa-solid fa-file-code"></i> Realizar reentrenamiento
                    </button>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mt-md-16">
                    <a href='/CreateDocuments'>
                      <button className="btn -primary">
                        <i class="fa-solid fa-file-arrow-up"></i> Subir documentos
                      </button>
                    </a>
                    
                  </div>
                </div>
               <TableDocuments data={rows} />
              </Tab>
              <Tab eventKey="trained" title="Entrenados">
                <div className="row mt-24 justify-content-end">
                  <div className="col-12 col-md-6 col-lg-4">
                    <button className="btn -secondary" onClick={trainingCompleted}>
                      <i class="fa-solid fa-file-code"></i> Realizar reentrenamiento
                    </button>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mt-md-16">
                  <a href='/CreateDocuments'>
                      <button className="btn -primary">
                        <i class="fa-solid fa-file-arrow-up"></i> Subir documentos
                      </button>
                    </a>
                  </div>
                </div>
                <TableDocuments data={rowsTrained} />
              </Tab>
              <Tab eventKey="rejected" title="Rechazados">
                <div className="row mt-24 justify-content-end">
                  <div className="col-12 col-md-6 col-lg-4">
                    <button className="btn -secondary" onClick={trainingCompleted}>
                      <i class="fa-solid fa-file-code"></i> Realizar reentrenamiento
                    </button>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mt-md-16">
                  <a href='/CreateDocuments'>
                      <button className="btn -primary">
                        <i class="fa-solid fa-file-arrow-up"></i> Subir documentos
                      </button>
                    </a>
                  </div>
                </div>
                <TableDocuments data={rowsRejected} />
              </Tab>
              <Tab eventKey="approved" title="Aprobados">
                <div className="row mt-24 justify-content-end">
                  <div className="col-12 col-md-6 col-lg-4">
                    <button className="btn -secondary" onClick={trainingCompleted}>
                      <i class="fa-solid fa-file-code"></i> Realizar reentrenamiento
                    </button>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mt-md-16">
                  <a href='/CreateDocuments'>
                      <button className="btn -primary">
                        <i class="fa-solid fa-file-arrow-up"></i> Subir documentos
                      </button>
                    </a>
                  </div>
                </div>
                <TableDocuments data={rowsApproved} />
              </Tab>
            </Tabs>
          </div>
        </>
        {/* Main page, tabs view */}

      </div>
    </div>
  );
}

export default AdminDocuments;